const sanitizeSettings = {
    allowedTags: ["b", "i", "em", "strong", "strike", "br", "div", "u", "p"],
};

export default sanitizeSettings;
